<div id="login" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="assets/images/logos/bodyspace_login.png">
            </div>

            <div class="title">{{'LOGIN TO YOUR ACCOUNT'|translate}}</div>

            <mat-error *ngIf="isNotOnlineError">{{'If you want to login then you should be at work!'|translate}}</mat-error>

            <form name="loginForm" [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit()">


                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="username">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="loginForm.get('username').hasError('required')">
                        {{'Email is required'|translate}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'Password'|translate}}</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        {{'Password is required'|translate}}
                    </mat-error>
                </mat-form-field>

                <button mat-raised-button color="accent" class="submit-button" aria-label="LOG IN"
                        [disabled]="loginForm.invalid || loading">
                    {{'LOGIN'|translate}}
                </button>

            </form>

        </div>

    </div>

</div>
